import { Plugin } from 'ckeditor5'

/**
 * Plugin to add data-id attribute to text elements.
 * Plain text elements in the input get converted to span elements so we can add the data-id attribute.
 */
export class TextIdPlugin extends Plugin {
    public init = () => {
        this._defineSchema()
        this._defineConverters()
    }

    private _defineSchema = () => {
        const editor = this.editor
        editor.model.schema.extend('$text', {
            allowAttributes: 'id',
        })
    }

    private _defineConverters = () => {
        const editor = this.editor

        // Convert plain text to span element with data-id attribute.
        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'span',
                classes: 'paragraph-text',
            },
            model: {
                key: 'id',
                value: (viewElement: any): any =>
                    viewElement.getAttribute('data-id'),
            },
        })

        // Convert span element with data-id attribute to plain text.
        editor.conversion.for('downcast').attributeToElement({
            model: 'id',
            view: (
                attributeValue: any,
                { writer: viewWriter }: { writer: any }
            ): any =>
                viewWriter.createAttributeElement('span', {
                    class: 'paragraph-text',
                    'data-id': attributeValue,
                }),
        })
    }
}
